export enum Pathnames {
  NEW = "/new",
  CONVERSATION = "/conversation",
  PAGE = "/page",
  ADMIN = "/admin",
  ADMIN_WORKSPACES = "/workspaces",
}
